import { SetterOrUpdater } from "recoil"
import { MobergDropdown, MobergDropdownSize } from "../../../Components/MobergDropdown/MobergDropdown"
import React from "react"
import { EEG_HIGH_FILTERS, EEG_LOW_FILTERS, EEG_NOTCH_FILTERS } from "../../../Pages/Data/Visualize/DataReview/Types/EEG"
import { MobergButton, MobergButtonShape } from "../../../Components/MobergButton/MobergButton"
import { useMobergMenu } from "../../../Hooks/useMobergMenu"
import { MdMoreHoriz } from "react-icons/md"
import { MobergIconSize } from "../../../Components/MobergIcon/MobergIcon"

type EEGFilters = {
    LFF: number
    HFF: number
    notch: number
}

type EEGCollapseMenuProps<T extends EEGFilters> = {
    eegConfig: T
    setEEGConfig: SetterOrUpdater<T>
}

export const EEGCollapseMenu = <T extends EEGFilters>({ eegConfig, setEEGConfig }: EEGCollapseMenuProps<T>) => {
    const { open, MobergMenu } = useMobergMenu({ placement: "bottom", tryToKeepMenuOpen: true })

    return (<>
        <MobergButton onClick={open} shape={MobergButtonShape.SQUARE}>
            <MdMoreHoriz size={MobergIconSize.SMALL} />
        </MobergButton>

        <MobergMenu style={{ marginTop: "5px", padding: "8px 12px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <MobergDropdown 
                    label={"LFF"}
                    selectedValue={eegConfig.LFF} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, LFF: parseFloat(value as string) }))}
                    options={Object.entries(EEG_LOW_FILTERS).map(([label, value]) => ({ label, value }))} />
            
                <MobergDropdown 
                    label={"HFF"}
                    selectedValue={eegConfig.HFF} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, HFF: parseFloat(value as string) }))}
                    options={Object.entries(EEG_HIGH_FILTERS).map(([label, value]) => ({ label, value }))} />
            
                <MobergDropdown 
                    label={"Notch"}
                    selectedValue={eegConfig.notch} 
                    size={MobergDropdownSize.SMALL}
                    onChange={value => setEEGConfig(previous => ({ ...previous, notch: parseFloat(value as string) }))}
                    options={Object.entries(EEG_NOTCH_FILTERS).map(([label, value]) => ({ label, value }))} />
            </div>
        </MobergMenu>
    </>)
} 
